import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const links = [{
  name: 'Recap',
  href: '#recap'
}, {
  name: 'Approach',
  href: '#approach'
}, {
  name: 'Included',
  href: '#included'
}, {
  name: 'Pricing',
  href: '#pricing'
}, {
  name: 'Timeline',
  href: '#timeline'
}, {
  name: 'Terms',
  href: '#terms'
}, {
  name: 'Next',
  href: '#next'
}];
export function FooterNav() {
  const [activeSection, setActiveSection] = useState('');
  useEffect(() => {
    const handleScroll = () => {
      const sections = links.map(l => l.href.substring(1));
      const pos = window.scrollY + window.innerHeight / 2;
      for (const s of sections) {
        const el = document.getElementById(s);
        if (el) {
          const {
            offsetTop,
            offsetHeight
          } = el;
          if (pos >= offsetTop && pos < offsetTop + offsetHeight) {
            setActiveSection(s);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed bottom-5 md:bottom-8 left-0 right-0 z-50 flex justify-center pointer-events-none px-3" data-id="element-86">
      <motion.div className="bg-ink/95 backdrop-blur-md rounded-full p-1 md:p-1.5 shadow-2xl pointer-events-auto flex items-center gap-0.5 md:gap-1 max-w-full overflow-x-auto scrollbar-hide" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 1,
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} data-id="element-87">
        {links.map(link => {
        const isActive = activeSection === link.href.substring(1);
        return <a key={link.name} href={link.href} className={`relative px-3 md:px-4 py-1.5 md:py-2 rounded-full text-[11px] md:text-xs uppercase tracking-[0.18em] font-medium transition-colors duration-300 whitespace-nowrap flex-shrink-0 ${isActive ? 'text-ink' : 'text-ivory/70 hover:text-ivory'}`} data-id="element-88">
              {isActive && <motion.div layoutId="activePill" className="absolute inset-0 bg-ivory rounded-full" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-89" />}
              <span className="relative z-10" data-id="element-90">{link.name}</span>
            </a>;
      })}
      </motion.div>
    </div>;
}